/**
 * @generated SignedSource<<432dd1cd355c0b450ee4da0d92927858>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastPickerButton_dasbhoards$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastPickerPopoverDashboards">;
  readonly " $fragmentType": "StorecastPickerButton_dasbhoards";
}>;
export type StorecastPickerButton_dasbhoards$key = ReadonlyArray<{
  readonly " $data"?: StorecastPickerButton_dasbhoards$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastPickerButton_dasbhoards">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "StorecastPickerButton_dasbhoards",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastPickerPopoverDashboards"
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "af3e820447703b4b5246536d57774e4a";

export default node;
